export default __webpack_public_path__ + "700a3cc67d8d6c546c5d0ab1600d1003.svg";